import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import moment from "moment";
import InstructionContainer from "../Instructions/InstructionContainer";
import { Text } from "react-internationalization";
import Button from "../../Utils/GenericUI/Button";
import { FieldLabel } from "../translations/dynamic";
import Step1Qsns from "./Step1Qsns";
import { mandatoryFileds } from "../../Utils/StaticData/MandatoryFields";
import {
  NEBRASKA_CONSTS,
  DataValidation,
  poArray,
  ILS_CONSTS,
} from "../../Utils/StaticData/Constant";
const ie =
  navigator.userAgent.indexOf("MSIE") > -1 ||
  navigator.userAgent.indexOf("rv:") > -1;
class Step1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formerEmpOfSharp: false,
    };
    this.validator = new SimpleReactValidator();
  }
  render() {
    const { data, selectedPlan, customerId } = this.props;
    const { Socialnumber } = this.props.data;
    const { formerEmpOfSharp } = this.state;
    return (
      <React.Fragment>
        <div
          class={
            data?.appStatus === "READY" || data?.appStatus === "SUBMITTED"
              ? "tab-content tab-contentSharp disable-form"
              : "tab-content tab-contentSharp"
          }
        >
          <div id="step1" class="container-Cambia tab-pane active">
            <React.Fragment>
              <InstructionContainer selectedPlan={selectedPlan} />
              <br />
              <h3 class="tab-heading display-flex jcsp">
                <Text id="app.STEP1" /> – <Text id="app.stepSub" />
              </h3>
            </React.Fragment>
            <div class="form-panel">
              <p>
                <strong>
                  {FieldLabel("Apara", customerId)}
                  {" :"}
                </strong>
              </p>

              <div class="form-group row">
                {formerEmpOfSharp ? (
                  <div class="col-md-3">
                    <label for="Socialnumber" class="control-label">
                      <Text id="app.Socialnumber" />*
                    </label>
                    <input
                      type="text"
                      id="Socialnumber"
                      name="Socialnumber"
                      value={Socialnumber}
                      onChange={this.props.handleNumberChange}
                      class={
                        Socialnumber.length != 9
                          ? "error-input"
                          : "form-control"
                      }
                      required=""
                      maxLength="9"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                ) : null}
              </div>
              <div class="form-group row">
                <div class={"col-md-3"}>
                  <fieldset class={ie ? "radio iemargin3" : "radio"}>
                    <legend>
                      <Text id="app.Prefix" />
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="MR"
                        name="prefix"
                        class="custom-control-input"
                        value="MR."
                        checked={data.prefix === "MR." ? true : false}
                        onChange={this.props.handleChange}
                      />
                      <label for="MR" class="radio-inline custom-control-label">
                        <Text id="app.Mr" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="MRS"
                        name="prefix"
                        class="custom-control-input"
                        value="MRS."
                        checked={data.prefix === "MRS." ? true : false}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="MRS"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Mrs" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="MS"
                        name="prefix"
                        class="custom-control-input"
                        value="MS."
                        checked={data.prefix === "MS." ? true : false}
                        onChange={this.props.handleChange}
                      />
                      <label for="MS" class="radio-inline custom-control-label">
                        <Text id="app.Ms" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="DR"
                        name="prefix"
                        class="custom-control-input"
                        value="DR."
                        checked={data.prefix === "DR." ? true : false}
                        onChange={this.props.handleChange}
                      />
                      <label for="DR" class="radio-inline custom-control-label">
                        Dr
                      </label>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-3">
                  <label for="firstName" class="control-label">
                    <Text id="app.FirstName" />
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={data.firstName}
                    maxLength="20"
                    onChange={(event) => {
                      if (
                        event.target.value !== "" &&
                        !DataValidation.test(event.target.value)
                      ) {
                        return;
                      }
                      this.props.handleChange(event);
                    }}
                    class={
                      data.firstName === "" || data.firstName === undefined
                        ? "error-input"
                        : "form-control"
                    }
                    required=""
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div class="col-md-3">
                  <label for="middleInitial" class="control-label">
                    <Text id="app.MI" />
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={data.middleInitial}
                    onChange={(event) => {
                      if (
                        event.target.value !== "" &&
                        !DataValidation.test(event.target.value)
                      ) {
                        return;
                      }
                      this.props.handleChange(event);
                    }}
                    id="middleInitial"
                    name="middleInitial"
                    maxLength="20"
                    required=""
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div class="col-md-3">
                  <label for="lastName" class="control-label">
                    <Text id="app.LastName" />
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    class={
                      data.lastName === "" || data.lastName === undefined
                        ? "error-input"
                        : "form-control"
                    }
                    value={data.lastName}
                    maxLength="20"
                    onChange={(event) => {
                      if (
                        event.target.value !== "" &&
                        !DataValidation.test(event.target.value)
                      ) {
                        return;
                      }
                      this.props.handleChange(event);
                    }}
                    name="lastName"
                    required=""
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-3">
                  <label for="birthDate" class="control-label">
                    {/* <Text id="app.BirthDate" /> */}
                    {FieldLabel("birthDate", customerId)}
                  </label>
                  <input
                    class={
                      data.birthDate === "" ||
                      !moment(data.birthDate, "MM/DD/YYYY", true).isValid()
                        ? "error-input scrollfix"
                        : "form-control  scrollfix"
                    }
                    value={data.birthDate}
                    maxLength="10"
                    onChange={this.props.handleDate}
                    onClick={(e) => this.props.handleDates("birthDate")}
                    name="birthDate"
                    id="birthDate"
                    placeholder="MM/DD/YYYY"
                    required=""
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div class="col-md-3">
                  <label class="control-label" for="sex">
                    <Text id="app.Sex" />
                  </label>
                  <select
                    name="sex"
                    id="sex"
                    class={
                      this.props.data.sex === "" ||
                      this.props.data.sex === undefined
                        ? "error-input"
                        : "form-control"
                    }
                    value={data.sex}
                    onChange={this.props.handleChange}
                  >
                    <option value="">Select...</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    {customerId !== NEBRASKA_CONSTS.ID && (
                      <option value="U">Unknown</option>
                    )}
                  </select>
                </div>
                <div class="col-md-3">
                  <label for="primaryPhoneNum" class="control-label">
                    <Text id="app.PrimaryPhoneNumber" />
                  </label>
                  <input
                    type="text"
                    id="primaryPhoneNum"
                    value={data.primaryPhoneNum}
                    onChange={this.props.handleChange}
                    name="primaryPhoneNum"
                    class={
                      data.primaryPhoneNum
                        ? data?.primaryPhoneNum === "" ||
                          data?.primaryPhoneNum?.length < 10
                          ? "error-input"
                          : "form-control"
                        : "error-input"
                    }
                    placeholder="(   )   -"
                    required=""
                    maxLength="14"
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>

                <div class="col-md-3">
                  <label for="proposedEffDate" class="control-label">
                    <Text id="app.propEffDate" />*
                  </label>
                  <input
                    class={
                      data.proposedEffDate === "" ||
                      this.props?.proposedvalid === false ||
                      !moment(
                        data.proposedEffDate,
                        "MM/DD/YYYY",
                        true
                      ).isValid()
                        ? "error-input  scrollfix"
                        : "form-control  scrollfix"
                    }
                    maxLength="10"
                    value={data.proposedEffDate}
                    onChange={this.props.handleDateNew}
                    onClick={(e) =>
                      this.props.handleReqEffDates("proposedEffDate")
                    }
                    name="proposedEffDate"
                    id="proposedEffDate"
                    placeholder="MM/DD/YYYY"
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>

                <div class="col-md-3">
                  <label for="alternatePhone" class="control-label">
                    <Text id="app.CellPhoneNumber" />
                  </label>
                  <input
                    type="text"
                    id="alternatePhone"
                    name="cellPhoneNum"
                    value={data.cellPhoneNum}
                    onChange={this.props.handleChange}
                    class="form-control"
                    placeholder="(   )   -"
                    maxLength="14"
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label for="permanentAddrStreet" class="control-label">
                    <Text id="app.PermanentAddress" />{" "}
                    <strong>
                      (<Text id="app.POBox" />
                      )*
                    </strong>
                  </label>
                  <input
                    type="text"
                    name="permanentAddrStreet"
                    id="permanentAddrStreet"
                    value={data.permanentAddrStreet}
                    maxLength="50"
                    onChange={this.props.handleChange}
                    class={
                      data.permanentAddrStreet
                        ? poArray.some((pos) =>
                            data.permanentAddrStreet.trimStart().startsWith(pos)
                          )
                          ? "error-input"
                          : "form-control"
                        : "error-input"
                    }
                    required=""
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-3 display-grid">
                  <label for="permanentAddr2" class={"control-label"}>
                    <Text id="app.address2" />
                  </label>

                  <input
                    type="text"
                    class="form-control"
                    name="permanentAddr2"
                    id="permanentAddr2"
                    value={data.permanentAddr2}
                    maxLength="50"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div
                  class={
                    window.innerWidth <= 1240
                      ? "col-md-4 display-grid"
                      : "col-md-3 display-grid"
                  }
                >
                  <label
                    for="permanentCity"
                    class={
                      this.props?.filteredCity
                        ? this.props.filteredCity.length > 1
                          ? " control-label"
                          : "control-label"
                        : "control-label"
                    }
                  >
                    <Text id="app.City" />*
                  </label>
                  {this.props?.filteredCity &&
                  this.props.filteredCity?.length > 1 ? (
                    <select
                      value={data.permanentCity}
                      onChange={this.props.handleChange}
                      name="permanentCity"
                      id="permanentCity"
                      class="form-control county-pad"
                    >
                      {this.props.filteredCity.map((city) => (
                        <option value={city.cityName?.trimEnd().slice(0, 20)}>
                          {city.cityName}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      class={
                        data.permanentCity === ""
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.permanentCity}
                      maxLength="20"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.props.handleChange(event);
                      }}
                      name="permanentCity"
                      id="permanentCity"
                      required=""
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  )}
                </div>

                <div class="col-md-3 display-grid">
                  <label
                    for="permanentCounty"
                    class={
                      this.props?.ZipCodes
                        ? this.props.ZipCodes.length > 1
                          ? " control-label"
                          : "control-label"
                        : "control-label"
                    }
                  >
                    <Text id="app.County" />
                  </label>
                  {this.props?.ZipCodes && this.props.ZipCodes.length > 1 ? (
                    <select
                      id="permanentCounty"
                      name="permanentCounty"
                      value={data.permanentCounty}
                      onChange={this.props.handleChange}
                      class="form-control county-pad"
                    >
                      {this.props.ZipCodes.map((county) => (
                        <option value={county.countyName}>
                          {county.countyName}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      class="form-control cursor-not-allowed"
                      name="permanentCounty"
                      id="permanentCounty"
                      value={
                        this?.props?.mbiDetails?.status === "MATCHED"
                          ? data?.permanentCounty
                          : this.props.preEnrollInfo.appNumber
                          ? this.props.deeplink
                            ? this.props.dpcountyName
                            : this.props.preEnrollInfo.permanentAddress.county
                          : this.props.deeplink
                          ? this.props.dpcountyName
                          : this.props?.ZipCodes[0]?.countyName
                      }
                      disabled
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  )}
                </div>

                <div class="col-md-3">
                  <label for="permanentState" class="control-label">
                    <Text id="app.State" />
                  </label>
                  <input
                    type="text"
                    class="form-control cursor-not-allowed"
                    name="permanentState"
                    id="permanentState"
                    value={
                      this?.props?.mbiDetails?.status === "MATCHED"
                        ? this.props.stateId
                        : this.props.preEnrollInfo.appNumber
                        ? this.props.deeplink
                          ? this.props.stateId
                          : this.props.preEnrollInfo.permanentAddress.state
                        : this.props.stateId
                    }
                    disabled
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>

                <div class="col-md-3">
                  <label for="permanentZip" class="control-label">
                    <Text id="app.ZIPCode" />*
                  </label>
                  <input
                    type="text"
                    class={
                      this.props.zipCode === "" && data.permanentZip === ""
                        ? this.props.deeplink
                          ? this.props.dpzipCode
                            ? "form-control"
                            : "error-input"
                          : "error-input"
                        : "form-control"
                    }
                    name="permanentZip"
                    id="permanentZip"
                    minlength="5"
                    value={
                      this.props?.zipCode !== ""
                        ? this.props?.zipCode
                        : this.props?.deeplink
                        ? this.props?.dpzipCode
                        : this.props?.preEnrollInfo?.permanentAddress?.zipCode
                    }
                    onChange={this.props.handleNumberChange}
                    maxLength="5"
                    disabled="true"
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div class="col-md-3">
                  <label for="permanentZip4" class="control-label">
                    <Text id="app.ZIPCode4" />
                  </label>
                  <input
                    type="text"
                    class={"form-control"}
                    name="permanentZip4"
                    id="permanentZip4"
                    value={data.permanentZip4}
                    onChange={this.props.handleChange}
                    onBlur={this.props.OnBlurpermananentZip4}
                    maxLength="4"
                    minLength="4"
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class={ie ? "display-inline-flex" : ""}>
                  <label for="language" class="control-label mr-2 neg-ml-4px">
                    <Text id="app.mailingaddress" />
                  </label>
                  <div class="custom-control custom-checkbox custom-control-inline mt-3">
                    <input
                      type="checkbox"
                      name="mailingAddressRequired"
                      id="mailingAddressRequired"
                      class="custom-control-input"
                      checked={data.mailingAddressRequired === "YES"}
                      onChange={this.props.handleCheckbox2}
                    />
                    <label
                      for="mailingAddressRequired"
                      class={
                        ie
                          ? "m-top-0 radio-inline custom-control-label"
                          : "m-top-auto radio-inline custom-control-label"
                      }
                    >
                      <strong>
                        <Text id="app.Yes" />
                      </strong>
                    </label>
                  </div>
                </div>
              </div>

              <div id="mailing-adddress">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label for="mailingAddr" class="control-label">
                      <Text id="app.maillingAdd" />
                      {mandatoryFileds[customerId]?.enrollmentForm
                        ?.mailingAddr && "*"}
                    </label>
                    <input
                      type="text"
                      class={
                        mandatoryFileds[customerId]?.enrollmentForm
                          ?.mailingAddr && !data.mailingAddr
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.mailingAddr}
                      maxLength="50"
                      onChange={this.props.handleChange}
                      name="mailingAddr"
                      id="mailingAddr"
                      required=""
                      disabled={
                        this.props.data.mailingAddressRequired === "YES"
                          ? true
                          : false
                      }
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-3">
                    <label for="mailingAddr2" class={"control-label"}>
                      <Text id="app.address2" />
                    </label>

                    <input
                      type="text"
                      class="form-control"
                      name="mailingAddr2"
                      id="mailingAddr2"
                      maxLength="50"
                      value={data.mailingAddr2}
                      onChange={this.props.handleChange}
                      disabled={
                        this.props.data.mailingAddressRequired === "YES"
                          ? true
                          : false
                      }
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="mailingCity" class="control-label">
                      <Text id="app.City" />
                      {mandatoryFileds[customerId]?.enrollmentForm
                        ?.mailingCity && "*"}
                    </label>
                    <input
                      type="text"
                      class={
                        mandatoryFileds[customerId]?.enrollmentForm
                          ?.mailingCity && !data.mailingCity
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.mailingCity}
                      maxLength="20"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.props.handleChange(event);
                      }}
                      name="mailingCity"
                      id="mailingCity"
                      required=""
                      disabled={
                        this.props.data.mailingAddressRequired === "YES"
                          ? true
                          : false
                      }
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-3 display-grid">
                    <label
                      for="permanentCounty"
                      class={
                        // this.props?.ZipCodes
                        //   ? this.props.ZipCodes.length > 1
                        //     ? " control-label"
                        //     : "control-label"
                        "control-label"
                      }
                    >
                      <Text id="app.County" />
                    </label>
                    {this.props?.mailzipCodes &&
                    this.props.mailzipCodes.length > 1 ? (
                      <select
                        id="mailingCounty"
                        name="mailingCounty"
                        value={data.mailingCounty}
                        onChange={this.props.handleChange}
                        class="form-control county-pad"
                        disabled={
                          this.props.data.mailingAddressRequired === "YES"
                            ? true
                            : false
                        }
                      >
                        {this.props.mailzipCodes.map((county) => (
                          <option value={county.countyName}>
                            {county.countyName}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        className={
                          //   data.mailingState === "" && this.props.data.mailingAddressRequired === "YES"
                          // ? "error-input"
                          "form-control"
                        }
                        name="mailingCounty"
                        id="mailingCounty"
                        maxLength="3"
                        value={data.mailingCounty}
                        onChange={(event) => {
                          if (
                            event.target.value !== "" &&
                            !DataValidation.test(event.target.value)
                          ) {
                            return;
                          }
                          this.props.handleChange(event);
                        }}
                        disabled={
                          this.props.data.mailingAddressRequired === "YES"
                            ? true
                            : false
                        }
                        // disabled
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    )}
                  </div>
                  <div class="col-md-3">
                    <label for="mailingState" class="control-label">
                      <Text id="app.State" />
                      {mandatoryFileds[customerId]?.enrollmentForm
                        ?.mailingState && "*"}
                    </label>
                    {this.props.mailzipCodes?.length <= 1 ? (
                      <input
                        type="text"
                        class={
                          mandatoryFileds[customerId]?.enrollmentForm
                            ?.mailingState && !data.mailingState
                            ? "error-input"
                            : "form-control"
                        }
                        name="mailingState"
                        id="mailingState"
                        value={data.mailingState}
                        onChange={(event) => {
                          if (
                            event.target.value !== "" &&
                            !DataValidation.test(event.target.value)
                          ) {
                            return;
                          }
                          this.props.handleChange(event);
                        }}
                        maxLength="2"
                        disabled={
                          this.props.data.mailingAddressRequired === "YES"
                            ? true
                            : false
                        }
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    ) : (
                      <select
                        name="mailingState"
                        id="mailingState"
                        class={
                          mandatoryFileds[customerId]?.enrollmentForm
                            ?.mailingState && !data.mailingState
                            ? "error-input"
                            : "form-control"
                        }
                        value={data.mailingState}
                        onChange={this.props.handleChange}
                        disabled={
                          this.props.data.mailingAddressRequired === "YES"
                            ? true
                            : false
                        }
                      >
                        {this.props.mailzipCodes.map((item, i) => {
                          return (
                            <option
                              class="select-option"
                              value={item.stateCd}
                              key={i}
                            >
                              {item.stateCd}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </div>

                  <div class="col-md-3">
                    <label for="mailingzip" class="control-label">
                      <Text id="app.ZIPCode" />
                      {mandatoryFileds[customerId]?.enrollmentForm
                        ?.mailingzip && "*"}
                    </label>
                    <input
                      type="text"
                      class={
                        mandatoryFileds[customerId]?.enrollmentForm
                          ?.mailingzip &&
                        (data.mailingzip?.length === undefined ||
                          data.mailingzip?.length < 5)
                          ? "error-input"
                          : "form-control"
                      }
                      name="mailingzip"
                      id="mailingzip"
                      minlength="5"
                      value={data.mailingzip}
                      onChange={this.props.handleChange}
                      maxLength="5"
                      required=""
                      disabled={
                        this.props.data.mailingAddressRequired === "YES"
                          ? true
                          : false
                      }
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="mailingZip4" class="control-label">
                      <Text id="app.ZIPCode4" />
                    </label>
                    <input
                      type="text"
                      class={"form-control"}
                      name="mailingZip4"
                      id="mailingZip4"
                      value={data.mailingZip4}
                      onChange={this.props.handleChange}
                      onBlur={this.props.OnBlurmailZip4}
                      maxLength="4"
                      minLength="4"
                      disabled={
                        this.props.data.mailingAddressRequired === "YES"
                          ? true
                          : false
                      }
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
              </div>
              {/* ) : null} */}

              <React.Fragment>
                <div class="form-group row">
                  <div
                    class={
                      this.props.agentLogin
                        ? "col-lg-3 col-md-3 col-sm-12"
                        : "col-md-6 col-lg-6 col-sm-12"
                    }
                  >
                    <p>
                      <label for="medicareNumber" class="control-label">
                        <Text id="app.MedicareNo" />*
                      </label>
                      <input
                        type="text"
                        placeholder="XXXXXXXXXXX"
                        name="medicareNumber"
                        id="medicareNumber"
                        minlength="10"
                        maxLength="11"
                        class={
                          data.medicareNumber === "" ||
                          data.medicareNumber === undefined ||
                          (data.medicareNumber &&
                            this.props.mandatoryMbi.length < 11)
                            ? "error-input"
                            : "form-control"
                        }
                        value={data.medicareNumber}
                        onChange={this.props.handleChange}
                        required=""
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </p>
                  </div>
                  {this.props.agentLogin === true && (
                    <div class="col-md-3 col-lg-3 col-sm-12">
                      <Button
                        className="btn btn-secondary-enroll chkbutton "
                        id="checkEligibity"
                        onButtonClick={this.props.checkEligibility}
                        buttonLabel={
                          this.props.lang === "en"
                            ? "Check Eligibility"
                            : "Verificar elegibilidad"
                        }
                      />
                    </div>
                  )}
                  <div class="col-md-3 col-lg-3 col-sm-12">
                    <p>
                      <label for="partAEffDate" class="control-label">
                        <Text id="app.partA" />
                        {this.props.customerId !== ILS_CONSTS.ID && "*"}
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="partAEffDate"
                        id="partAEffDate"
                        maxLength="10"
                        class={
                          this.props.customerId !== ILS_CONSTS.ID &&
                          (data.partAEffDate === "" ||
                            this.props?.partAvalid === false ||
                            !moment(
                              data.partAEffDate,
                              "MM/DD/YYYY",
                              true
                            ).isValid())
                            ? "error-input scrollfix"
                            : this.props.customerId === ILS_CONSTS.ID &&
                              !moment(
                                data.partAEffDate,
                                "MM/DD/YYYY",
                                true
                              ).isValid() &&
                              data.partAEffDate !== ""
                            ? "error-input scrollfix"
                            : "form-control scrollfix"
                        }
                        value={data.partAEffDate}
                        required=""
                        onChange={this.props.handleDateNew}
                        onClick={(e) => this.props.handleDates("partAEffDate")}
                        placeholder="MM/DD/YYYY"
                      />
                    </p>
                  </div>
                  <div class="col-md-3 col-lg-3 col-sm-12">
                    <p>
                      <label for="partBEffDate" class="control-label">
                        <Text id="app.partB" />
                        {this.props.customerId !== ILS_CONSTS.ID && "*"}
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="partBEffDate"
                        id="partBEffDate"
                        maxLength="10"
                        class={
                          this.props.customerId !== ILS_CONSTS.ID &&
                          (data.partBEffDate === "" ||
                            !moment(
                              data.partBEffDate,
                              "MM/DD/YYYY",
                              true
                            ).isValid() ||
                            this.props?.partBvalid === false)
                            ? "error-input scrollfix"
                            : this.props.customerId === ILS_CONSTS.ID &&
                              !moment(
                                data.partBEffDate,
                                "MM/DD/YYYY",
                                true
                              ).isValid() &&
                              data.partBEffDate !== ""
                            ? "error-input scrollfix"
                            : "form-control scrollfix"
                        }
                        value={data.partBEffDate}
                        required=""
                        onChange={this.props.handleDateNew}
                        onClick={(e) => this.props.handleDates("partBEffDate")}
                        placeholder="MM/DD/YYYY"
                      />
                    </p>
                  </div>
                </div>
                <Step1Qsns
                  productName={this.props.productName}
                  handleChange={this.props.handleChange}
                  customerId={customerId}
                  data={data}
                  statesList={this.props.statesList}
                  OnBlurauthZip4={this.props.OnBlurauthZip4}
                  authorizedrelations={this.props.authorizedrelations}
                  agentLogin={this.props.agentLogin}
                  salesreplist={this.props.salesreplist}
                  isAgentLogin={this.props.isAgentLogin}
                  handleDate={this.props.handleDate}
                  handleDates={this.props.handleDates}
                />
              </React.Fragment>
              {this.props.preEnrollInfo?.appStatus != "READY" &&
                this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                  <button
                    class="btn btn-saveNext"
                    id="next1"
                    onClick={this.props.redirect}
                    disabled={
                      this.props?.Submitted ||
                      this.props.preEnrollInfo?.appStatus === "READY" ||
                      this.props.preEnrollInfo?.appStatus === "SUBMITTED"
                    }
                  >
                    <Text id="app.Save_Next" />
                  </button>
                )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    year,
    zip,
    zipCodes,
    stateCd,
    language,
    authorizedrelations,
    preEnrollInfo,
    stateId,
  } = state.webApp;
  return {
    year,
    lang: language,
    stateCd: stateCd,
    stateId: stateId,
    ZipCodes: zipCodes,
    zipCode: zip,
    authorizedrelations: authorizedrelations,
    preEnrollInfo: preEnrollInfo,
    dpStateCd: state.login.dpStateCd,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    salesreplist:
      state.campaignProspect.salesreplist.length > 0
        ? state.campaignProspect.salesreplist
        : state.campaignProspect.agentList,
    Submitted: state.webApp.Submitted,
    statesList: state.login.statesList,
    // mailingZipCodes: state.webApp.mailingZipCodes,
    isAgentLogin: state.login.agentLoggedIn,
    mailzipCodes: state.campaignProspect.mailzipCodes,
    mbiDetails: state.login.mbiDetails,
    customerId: state.login.customerId,
  };
};
export default connect(mapStateToProps)(Step1);
